import { FETCH_SPECS } from './constants'

const intialState = {
  isFetching: false,
  currentPhoneInfo: {},
  currentPhoneId: ''
}

export default function reducer(state = intialState, action) {
  switch (action.type) {
    case FETCH_SPECS['REQUEST']: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_SPECS['SUCCESS']: {
      return {
        ...state,
        isFetching: false,
        currentPhoneInfo: action.specs
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/Specs/reducer.js